var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.503 3v4.399M21.298 3v4.399m7.503 8.73V8.93c0-2.061-1.67-3.732-3.732-3.732H6.732A3.732 3.732 0 0 0 3 8.931v16.133c0 2.061 1.67 3.732 3.732 3.732H15m1.156-3.47L15 30.85l5.525-1.157m8.738-13.106L18.985 26.866m1.553 2.842-1.553-2.842-2.829-1.54L26 15.456a1.554 1.554 0 0 1 2.197 0l2.198 2.197a1.554 1.554 0 0 1 0 2.198l-9.857 9.857z",
    stroke: "#22272A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.067 15.783H12.1V12.75H9.067v3.033zm0 6.284H12.1v-3.034H9.067v3.034zm5.416-6.284h3.034V12.75h-3.034v3.033zm0 6.25h3.034V19h-3.034v3.033zm5.417-6.25h3.033V12.75H19.9v3.033zm0 6.25 1.517-1.915L22.933 19H19.9v3.033z",
    fill: "#22272A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarEdit);
export default __webpack_public_path__ + "static/media/calendarEdit.c639913c5e269373930635748a52ab21.svg";
export { ForwardRef as ReactComponent };